<template>
  <div class="login_container">
    <div class="login_content">
      <!-- 左侧装饰区域 -->
      <div class="decoration_area">
        <div class="decoration_content">
          <h1 class="brand_title">Namzar</h1>
          <p class="slogan">Unleash Your Inner Drive</p>
          <div class="decoration_svg">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <path fill="rgba(255,255,255,0.1)" d="M45,-51.5C59.1,-42.3,71.7,-29.2,76.3,-13.2C80.9,2.8,77.5,21.7,67.8,36.1C58.1,50.5,42,60.4,25.1,64.8C8.1,69.2,-9.8,68,-26.1,62C-42.4,56,-57.1,45.2,-65.2,30.3C-73.4,15.4,-75,-3.7,-69.7,-20.4C-64.4,-37.1,-52.1,-51.4,-37.8,-60.5C-23.4,-69.6,-7,-73.5,4.9,-69.1C16.8,-64.7,30.9,-60.7,45,-51.5Z" transform="translate(100 100)" />
            </svg>
          </div>
        </div>
      </div>

      <!-- 右侧登录区域 -->
      <div class="login_box">
        <div class="login_header">
          <h2>Namzar CMS</h2>
          <p>Made by PopOut with ❤️</p>
        </div>

        <!-- 登录/注册切换标签 -->
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="auth-tabs">
          <el-tab-pane label="Login" name="login">
        <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" @keyup.native.enter="login">
          <el-form-item prop="username">
            <el-input 
              v-model="loginForm.username"
              clearable
              placeholder="Please enter your username"
              prefix-icon="el-icon-user">
            </el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input 
              v-model="loginForm.password"
              show-password
              type="password"
              placeholder="Please enter your password"
              prefix-icon="el-icon-lock">
            </el-input>
          </el-form-item>

          <el-form-item class="btns">
            <el-button type="primary" @click="login" class="login_btn">Login</el-button>
          </el-form-item>
        </el-form>
          </el-tab-pane>

          <el-tab-pane label="Register" name="register">
            <el-form ref="registerFormRef" :model="registerForm" :rules="registerFormRules" @keyup.native.enter="register">
              <el-form-item prop="username">
                <el-input 
                  v-model="registerForm.username"
                  clearable
                  placeholder="Please enter your username (≥3 characters)"
                  prefix-icon="el-icon-user">
                </el-input>
              </el-form-item>

              <el-form-item prop="email">
                <el-input 
                  v-model="registerForm.email"
                  clearable
                  placeholder="Please enter your email"
                  prefix-icon="el-icon-message">
                </el-input>
              </el-form-item>

              <el-form-item prop="password">
                <el-input 
                  v-model="registerForm.password"
                  show-password
                  type="password"
                  placeholder="Please enter your password (≥6 characters)"
                  prefix-icon="el-icon-lock">
                </el-input>
              </el-form-item>

              <el-form-item class="btns">
                <el-button type="primary" @click="register" class="login_btn">Register</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="footer_info">
      <span>© 2025 PopOut. All Rights Reserved.</span>
      <a href="http://beian.miit.gov.cn" target="_blank">京ICP备2024087685号-4</a>
    </div>
  </div>
</template>

<script>
import { setToken } from '@/utils/auth'

export default {
    name: 'Login',
    data(){
      return {
        activeTab: 'login',
        loginForm: {
          username: '',
          password: ''
        },
        loginFormRules: {
          username: [
            { required: true, message: 'Please enter your username', trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'Please enter your password', trigger: 'blur' }
          ]
        },
        registerForm: {
          username: '',
          email: '',
          password: ''
        },
        registerFormRules: {
          username: [
            { required: true, message: 'Please enter your username', trigger: 'blur' },
            { min: 3, message: 'Username must be at least 3 characters', trigger: 'blur' }
          ],
          email: [
            { required: true, message: 'Please enter your email', trigger: 'blur' },
            { type: 'email', message: 'Please enter a valid email address', trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'Please enter your password', trigger: 'blur' },
            { min: 6, message: 'Password must be at least 6 characters', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      handleTabClick(tab) {
        // 切换标签时清空表单验证状态
        if (tab.name === 'login') {
          this.$refs.registerFormRef && this.$refs.registerFormRef.clearValidate()
        } else {
          this.$refs.loginFormRef && this.$refs.loginFormRef.clearValidate()
        }
      },
      login(){
        this.$refs.loginFormRef.validate(valid => {
          if(!valid) return
          this.request({
            method: 'post',
            url: 'login',
            data: this.loginForm
          }).then(res => {
            this.$message.success("登录成功");
            setToken(res.access_token)
            localStorage.setItem('namzar-admin-username', this.loginForm.username || '管理员')
            if (res.role_name) {
              localStorage.setItem('namzar-admin-role', res.role_name)
            }
            this.$router.push('/admin/welcome')
          }).catch(res => {
            this.$message.error(res?.message || '登录失败')
          })
        });
      },
      register(){
        this.$refs.registerFormRef.validate(valid => {
          if(!valid) return
          this.request({
            method: 'post',
            url: 'register',
            data: this.registerForm
          }).then(res => {
            this.$message.success(res.message || "注册成功");
            // 注册成功后保存 token 和用户信息
            if (res.token) {
              setToken(res.token)
            }
            if (res.user) {
              localStorage.setItem('namzar-admin-username', res.user.username || '管理员')
              if (res.user.role_name) {
                localStorage.setItem('namzar-admin-role', res.user.role_name)
              }
            }
            // 跳转到欢迎页面
            this.$router.push('/admin/welcome')
          }).catch(res => {
            this.$message.error(res?.message || '注册失败')
          })
        });
      }
    }
}
</script>

<style scoped>
.login_container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login_content {
  display: flex;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  width: 900px;
  height: 550px;
  margin-top: 40px;
  backdrop-filter: blur(10px);
}

/* 优化左侧装饰区域 */
.decoration_area {
  flex: 1;
  background: linear-gradient(45deg, #667eea 0%, #764ba2 100%);
  padding: 60px;
  position: relative;
  overflow: hidden;
}

.decoration_content {
  position: relative;
  z-index: 1;
}

.brand_title {
  font-size: 3.5em;
  margin-bottom: 20px;
  font-weight: 700;
  color: white;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
}

.slogan {
  font-size: 1.4em;
  color: rgba(255,255,255,0.9);
}

/* 添加动画SVG样式 */
.decoration_svg {
  position: absolute;
  bottom: -50px;
  right: -50px;
  width: 300px;
  height: 300px;
  animation: rotate 20s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 优化右侧登录区域 */
.login_box {
  flex: 1;
  padding: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login_header {
  text-align: center;
  margin-bottom: 50px;
}

.login_header h2 {
  font-size: 2em;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.login_header p {
  color: #666;
  font-size: 1.1em;
}

/* 标签页样式 */
.auth-tabs {
  margin-top: 20px;
}

:deep(.el-tabs__header) {
  margin-bottom: 30px;
}

:deep(.el-tabs__item) {
  font-size: 16px;
  font-weight: 500;
  padding: 0 30px;
}

:deep(.el-tabs__active-bar) {
  background: linear-gradient(45deg, #667eea, #764ba2);
}

:deep(.el-tabs__item.is-active) {
  color: #667eea;
}

:deep(.el-tabs__item:hover) {
  color: #667eea;
}

/* 优化表单样式 */
:deep(.el-input__inner) {
  height: 50px;
  background: #f8f9fa;
  border-radius: 10px;
  transition: all 0.3s ease;
}

:deep(.el-input__inner:focus) {
  background: white;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102,126,234,0.2);
}

.login_btn {
  width: 100%;
  padding: 12px 0;
  font-size: 16px;
  border-radius: 10px;
  margin-top: 20px;
  height: 50px;
  background: linear-gradient(45deg, #667eea, #764ba2);
  border: none;
  transition: transform 0.3s ease;
}

.login_btn:hover {
  transform: translateY(-2px);
}

.footer_info {
  padding: 15px 0;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  margin-top: 30px;
}

.footer_info span {
  margin: 0 15px;
}

.footer_info a {
  color: rgba(255, 255, 255, 0.5);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer_info a:hover {
  font-size: 14px;
  font-weight: normal;
  color: rgba(255, 255, 255, 0.7);
}
</style>